import { apiService } from './api';
import { PaginationParams } from '../types/common';
import { CitiesResponse, City, CreateCityRequest, UpdateCityRequest } from '../types/client';

class CityService {
  async getCities(params?: PaginationParams & { countryId?: string; status?: 'ACTIVE' | 'INACTIVE' }): Promise<CitiesResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params?.countryId) queryParams.append('countryId', params.countryId);
    if (params?.status) queryParams.append('status', params.status);

    return apiService.get<CitiesResponse>(`/cities?${queryParams.toString()}`);
  }

  async createCity(data: CreateCityRequest): Promise<{ message: string; city: City }> {
    return apiService.post<{ message: string; city: City }>(`/cities`, data);
  }

  async updateCity(id: string, data: UpdateCityRequest): Promise<{ message: string; city: City }> {
    return apiService.put<{ message: string; city: City }>(`/cities/${id}`, data);
  }

  async deleteCity(id: string): Promise<{ message: string }> {
    return apiService.delete<{ message: string }>(`/cities/${id}`);
  }

  async bulkUpdateCityStatus(ids: string[], status: 'ACTIVE' | 'INACTIVE'): Promise<{ success: boolean; message: string; count: number }> {
    return apiService.post<{ success: boolean; message: string; count: number }>(`/cities/bulk-status`, { ids, status });
  }

  async exportCities(params?: { search?: string; countryId?: string; status?: 'ACTIVE' | 'INACTIVE'; ids?: string[] }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.countryId) queryParams.append('countryId', params.countryId);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.ids && params.ids.length) queryParams.append('ids', params.ids.join(','));
    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/cities/export?${queryParams.toString()}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Export failed');
    return response.blob();
  }
}

export const cityService = new CityService();

